import {DomainEvent} from './DomainEvent';
import {CompetitionSeason} from '../resources/CompetitionSeason';

export class CompetitionSeasonCreated extends DomainEvent<CompetitionSeason> {}
